import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'

class Carriers extends Component {
  componentDidMount() {}

  render() {
    return (
      <Card>
        <CardHeader title="Carriers" />
        <CardContent>Carriers</CardContent>
      </Card>
    )
  }
}

export default Carriers
